import { SvgIcon, SvgIconProps } from '@mui/material'

export function Infor(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 48 48" role="img" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.79721 8.79719C12.6863 4.90812 18.0634 2.5 24 2.5C29.9366 2.5 35.3137 4.90812 39.2028 8.7972L38.1421 9.85786L39.2028 8.79721C43.0919 12.6863 45.5 18.0634 45.5 24C45.5 29.9366 43.0919 35.3137 39.2028 39.2028C35.3137 43.0919 29.9366 45.5 24 45.5C18.0634 45.5 12.6863 43.0919 8.79721 39.2028L9.85786 38.1421L8.7972 39.2028C4.90812 35.3137 2.5 29.9366 2.5 24C2.5 18.0634 4.90812 12.6863 8.79719 8.79721L8.79721 8.79719ZM24 5.5C18.891 5.5 14.2681 7.56904 10.9185 10.9185C7.56902 14.2681 5.5 18.891 5.5 24C5.5 29.109 7.56904 33.7319 10.9185 37.0814C14.2681 40.4309 18.891 42.5 24 42.5C29.109 42.5 33.7319 40.4309 37.0814 37.0814C40.4309 33.7319 42.5 29.109 42.5 24C42.5 18.891 40.4309 14.2681 37.0814 10.9185C33.7319 7.56904 29.109 5.5 24 5.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 11C25.3807 11 26.5 12.1193 26.5 13.5C26.5 14.8807 25.3807 16 24 16C22.6193 16 21.5 14.8807 21.5 13.5C21.5 12.1193 22.6193 11 24 11Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 20C21 19.1716 21.6716 18.5 22.5 18.5H24.5C25.3284 18.5 26 19.1716 26 20V34C26 34.8284 25.3284 35.5 24.5 35.5C23.6716 35.5 23 34.8284 23 34V21.5H22.5C21.6716 21.5 21 20.8284 21 20Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5 34C19.5 33.1716 20.1716 32.5 21 32.5H28C28.8284 32.5 29.5 33.1716 29.5 34C29.5 34.8284 28.8284 35.5 28 35.5H21C20.1716 35.5 19.5 34.8284 19.5 34Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}
